import { useNavigate, useParams } from 'react-router-dom';

/** 使用页面跳转(支持将当前页面作为 from 参数跳到下个页面,下个页面可以通过 from 参数调回来) */
const useLocationFrom = () => {
  const navigate = useNavigate();

  /** 跳转到某个页面,携带当前页面作为 from 参数 */
  const navigateTo = (path: string) => {
    const fullPath = `${window.location.pathname}${window.location.search}`;
    const from = encodeURIComponent(fullPath);
    const to = `${path}?from=${from}`;
    navigate(to);
  };

  /** 返回上一步(考虑 from 参数) */
  const navigateBack = (defaultPath = '') => {
    const urlQuery = new URLSearchParams(window.location.search);
    const from = urlQuery.get('from');

    // 获取 from 参数
    if (from) {
      const decodedFrom = decodeURIComponent(from);
      navigate(decodedFrom);
    } else {
      // 兜底的跳转
      defaultPath ? navigate(defaultPath) : navigate(-1);
    }
  };

  return {
    navigateTo,
    navigateBack,
  };
};

export default useLocationFrom;
